import React from 'react';
import setPath from '@/lib/setPath';
import selectors from '@/redux/selectors/selectors';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import { query } from '@/redux/selectors/querySelectors.js';

const Dependency = ({ value, dependency }) => {
  const logId = useArgSelector(query, 'stepId');
  const indices = useArgSelector(query, 'indices');
  const step = useArgSelector(workflowScreenSelectors.activeWorkflowStepById, dependency?.stepId);
  const appName = useArgSelector(workflowScreenSelectors.activeWorkflowStepAppByStepId, dependency?.stepId)?.name;
  const workflowVersion = useArgSelector(selectors.param, 'workflowVersion');

  const stepId = dependency?.stepId;
  const prettyKey = String(dependency?.key).replace('response[0].', '');

  const handleClick = () => setPath(`/workflows/${step?.workflowId}/${workflowVersion}?logs=true&logId=${logId}&stepId=${stepId}&indices=${indices}`);

  return (
    <span className={`dependency ${!value ? 'empty' : ''}`} onClick={handleClick} data-title={`${step?.stepNumber}. ${appName} - ${prettyKey}`}>
      {value || 'Empty Value'}
    </span>
  );
};

export default Dependency;
